@if (!isOpen) {
  <l-icon
    (click)="menuToggled.emit()"
    class="absolute top-[18px] right-[34px] !text-2xl cursor-pointer text-lSecondary"
  >left_panel_open</l-icon>
}

@if (isOpen) {
  <div class="relative pr-10" lOutsideClick (outsideClick)="dropdownClosed.emit()">
    <l-icon
      (click)="menuToggled.emit()"
      class="absolute right-0 top-1/2 !text-2xl -translate-y-1/2 cursor-pointer text-lSecondary"
    >right_panel_open</l-icon>

    <div class="relative">
      <div class="flex items-center gap-3 rounded-xl bg-lBlack/15">
        <span class="rounded-xl bg-lPrimary px-5 py-3 text-base font-semibold leading-none text-white">
          {{ selectedModuleLabel }}
        </span>

        <button
          type="button"
          class="flex min-w-0 flex-1 items-center justify-between rounded-2xl px-2 py-2 text-left"
          [ngClass]="orderedModules.length > 1 ? 'cursor-pointer text-lFog' : 'cursor-default text-lSecondary'"
          (click)="dropdownToggled.emit($event)"
        >
          <span class="truncate text-base">{{ selectedModuleTitle }}</span>
          <l-icon class="text-lg transition-transform duration-200" [class.rotate-180]="isDropdownOpen">keyboard_arrow_down</l-icon>
        </button>
      </div>

      @if (isDropdownOpen) {
        <div class="absolute left-0 right-0 top-12 z-40 rounded-xl bg-lGray950 p-3 shadow">
          <div class="max-h-72 overflow-y-auto pr-1">
            @for (module of orderedModules; track module.id; let moduleIndex = $index) {
              <button
                type="button"
                class="mb-2 flex w-full items-center justify-between rounded-2xl pr-3 text-left transition-colors duration-150 last:mb-0"
                [ngClass]="[
                  module.id === selectedModule?.id ? 'bg-lGray850' : 'bg-transparent',
                  canAccessModule(moduleIndex) ? 'cursor-pointer text-lWhite hover:bg-lGray850/80' : 'cursor-not-allowed text-lSecondary/40'
                ]"
                (click)="onModuleClick(module.id, moduleIndex, $event)"
              >
                <div class="flex min-w-0 items-center gap-3">
                  <span class="rounded-2xl bg-lBlack px-4 py-2 text-base font-semibold text-lWhite">{{ moduleLabel(moduleIndex) }}</span>
                  <span class="truncate text-base" [ngClass]="canAccessModule(moduleIndex) ? 'text-lFog' : 'text-lSecondary/40'">{{ module.title }}</span>
                </div>

                @if (module.isCompleted) {
                  <span class="grid h-7 w-7 place-items-center rounded-full bg-lSuccessSoft text-white">
                    <l-icon class="text-sm">check</l-icon>
                  </span>
                } @else {
                  <span class="h-7 w-7"></span>
                }
              </button>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
